import { IntlShape } from 'react-intl';

export enum OUTCOME_TYPES {
  HOME = 'Home',
  DRAW = 'Draw',
  AWAY = 'Away',
  UNDER = 'Under',
  OVER = 'Over',
  YES = 'Yes',
  NO = 'No',
}

export const getOutcomeTranslation = (outcome: string, intl: IntlShape) => {
  switch (outcome.toUpperCase()) {
    case OUTCOME_TYPES.HOME.toUpperCase():
      return intl.formatMessage({ id: 'outcome.home' });
    case OUTCOME_TYPES.DRAW.toUpperCase():
      return intl.formatMessage({ id: 'outcome.draw' });
    case OUTCOME_TYPES.AWAY.toUpperCase():
      return intl.formatMessage({ id: 'outcome.away' });
    case OUTCOME_TYPES.UNDER.toUpperCase():
      return intl.formatMessage({ id: 'common.under' });
    case OUTCOME_TYPES.OVER.toUpperCase():
      return intl.formatMessage({ id: 'common.over' });
    case OUTCOME_TYPES.YES.toUpperCase():
      return intl.formatMessage({ id: 'common.yes' });
    case OUTCOME_TYPES.NO.toUpperCase():
      return intl.formatMessage({ id: 'common.no' });
    default:
      return outcome;
  }
};
